//========================================================================================================
// Use the css variables to edit exposed styles for this component
// Font styles can be inherited from the parent element
//========================================================================================================

import { countries } from "./countries.js";

(() => {
    const { defineCustomElement, ref, watchEffect, onMounted, nextTick  } = Vue;

    const FlagDisplay = defineCustomElement({
        props: ["country"],
        template: `<span class="flag-container" ref="flagElement" v-html="currentFlag"></span>`,
        styles:[`
            .flag-container svg {
                --svg-flag-component-width: 100%;
                width: var(--svg-flag-component-width);
                height: auto;
            }    
        `],
        setup(props) {
            const currentFlag = ref("");

            function updateFlag() {
                if (Array.isArray(countries) && countries.length > 0) {
                    const country = countries.find(country => country.id === props.country);
                    currentFlag.value = country ? country.flag : "";
                }
            }

            onMounted(() => {
                nextTick(() => {
                    updateFlag();
                });
            });

            watchEffect(() => {
                if (countries && countries.length > 0) {
                    updateFlag();
                }
            });

            return { currentFlag };
        },
    });

    customElements.define("flag-display", FlagDisplay);
})();
